/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable max-len */
export const dogBodylanguage = [
  {
    action: 'Humping people or dogs',
    meaning:
      'Humping is a sexual position for dogs, but veterinarians who specialize in canine behavior say it often is done for other reasons as well.  Humping is an attempt at dominance. This can apply whether it’s a human or another dog on the receiving end. Sometimes, it’s a sign that the dog is stressed, over-stimulated, or acting out.',
  },
  {
    action: 'Leash Aggression',
    meaning:
      'Leash aggression is when a dog shows aggressive behavior, such as barking or lunging, while on a leash. It is often due to frustration, fear, or feeling restrained by the leash. This behavior can result from a lack of socialization or past negative experiences. Training and behavior modification are crucial to address leash aggression and ensure safety.',
  },
  {
    action: 'Downward Dog',
    meaning:
      'When pups lean into this position, it typically means they’re ready for playtime',
  },
  {
    action: 'Eating poop',
    meaning:
      'Many things can cause coprophagy (the medical term for consuming feces). Your pup might be hungry. He could like the smell and taste. It’s possible he’s missing key nutrients from his diet.  If your dog is fond of eating poop, ask your veterinarian for help.',
  },
  {
    action: 'Licking the nose and lips',
    meaning:
      'Licking the nose and lips is a totally normal behavior while or after eating. However, constant licking during any other time could be a  sign of anxiety, fear or caution.',
  },
  {
    action: 'Lowering the body to the ground',
    meaning:
      'If your dog is is lowering their body to the ground in a cowerdly position, he/she is trying to make themselves smaller because the are likely afraid or anxious.',
  },
  {
    action: 'Tail Tucked Between Legs',
    meaning:
      'When your dog tucks their tail between their legs, it is a sure sign that he/she is afraid',
  },
  {
    action: 'Exposing Belly',
    meaning:
      'Your dog showing you his belly is a sure sign he/she feels safe when you’re around. It is a very submissive move. This means he/she trusts you and is looking for a generous tummy rub.',
  },
  {
    action: 'Sniffing butts',
    meaning:
      'A dog’s way of saying hello to another dog is to sniff the other dog’s butt. A dog’s ability to smell is 10,000 times better than ours, and, well, there are a lot of revealing aromas that come from a canine’s rear end.',
  },
  {
    action: 'Licking paws often',
    meaning:
      "Licking the paws constantly is usually a sign of extreme boredom. It could also mean your dog has a skin condion. Check with your vet as both causes could affect your pup's health.",
  },
  {
    action: 'Paw Lift',
    meaning:
      'A raised paw can mean uncertainty, appeasement, or focus on a scent (in hunting breeds).',
  },
  {
    action: 'Ears forward',
    meaning:
      'Ears that are perked up and facing forward usually mean thar your dog is alert or focused on something. They could easily switch gears and get aggressive or playful, depending on the scenario.',
  },
  {
    action: 'Ears low and back',
    meaning:
      "Slightly pulled-back ears signal that they're feeling friendly; but dog ears laid tightly back against the head suggest a fearful or timid reaction.",
  },
  {
    action: 'Licking humans',
    meaning:
      'Dogs licking their humans is a sign of affection. here\'s a pretty good chance that your dog is licking you because it loves you. It\'s why many people call them "kisses." Dogs show affection by licking people and sometimes even other dogs. Licking is a natural action for dogs.',
  },
  {
    action: 'Relaxed tail wagging',
    meaning:
      'If a dog is wagging its tail and the rest of its body seems relaxed or is moving along with the wagging, you are probably dealing with a happy, comfortable dog. Happy, relaxed tail wagging is usually accompanied by a happy facial expression. A happy dog usually has bright eyes, a relaxed open mouth, and possibly a gentle pant.',
  },
  {
    action: 'Tail Wagging Stiffly',
    meaning:
      'A stiff, high-speed wag may indicate excitement, arousal, or tension rather than friendliness.',
  },
  {
    action: 'Yawning',
    meaning:
      'Yawning in dogs indicates tiredness, stress, or serves as a calming signal to avoid conflict. It is commonly observed during waking moments, as they are falling asleep, or during quiet times such as early mornings or late nights.. Yawning increases in stressful situations such as car rides, vet visits, or during thunderstorms, often accompanied by panting and whining. Additionally, dogs use yawning as a strategy to diffuse potential conflicts and avoid confrontation.',
  },
  {
    action: 'Tightly closed mouth',
    meaning:
      'An open mouth typically indicates a relaxed and contented dog, while a tightly closed or clenched jaw suggests wariness or distrust towards something nearby.',
  },
  {
    action: 'Avoiding eye contact',
    meaning:
      'When dogs avoid eye contact, it usually indicates submission, fear, anxiety, or a desire to avoid conflict. It can also suggest discomfort or uncertainty in social situations and may be a way of showing deference to a more dominant individual or signaling non-aggression.',
  },
  {
    action: 'Left and right tail wagging',
    meaning:
      'it has been scientifically proven that if the dog is wagging their tail to the right, they’re experiencing positive emotions while to the left – they are feeling bad about something.',
  },
  {
    action: 'High-pitched bark',
    meaning:
      "Generally, a high-pitch bark is usually a positive thing, used when they want to tell others that they're not a threat or an invitation to play but can also be used when suddenly feel frightened.",
  },
  {
    action: 'Low-pitched bark',
    meaning:
      'A low-pitched bark or growl is a sign of a threatened dog, possibly aggressive and it would like to be left alone.',
  },
  {
    action: 'Howling',
    meaning:
      "Howling is your dog's way of communicating with you and the world. They howl to get attention, make contact with other dogs, and announce their presence.",
  },
  {
    action: 'Whining',
    meaning:
      'Dogs typically whine when they want something, like food, a toy, or attention. Whining can also show anxiety or fear.',
  },
  {
    action: 'Tilting the head',
    meaning:
      'A dog tilts his head to show that he is engaged much the way a human would nod during a conversation to indicate that he is listening.',
  },
  {
    action: 'Growling',
    meaning:
      'Growling during play does not mean your dog is aggressive. It simply means they’re having a great time. Of course, other growls have an entirely different meaning. A dog might growl to threaten another dog, or it might be a response to feeling cornered. ',
  },
  {
    action: 'Raised Hackles',
    meaning:
      'Raised hackles in dogs mean they are on high alert. They could be having a response brought on by fear, dominance, surprise, insecurity, or uneasiness about a situation.',
  },
  {
    action: 'Panting',
    meaning:
      'Dogs pant to cool themselves down on hot days. They also use it as a stress reliever. A constantly panting dog is a dog full of worry.',
  },
  {
    action: 'Sneezing',
    meaning:
      'Sneezing in dogs can signal various things. Occasional sneezing may result from irritation or excitement, while frequent sneezing could indicate health issues like allergies or respiratory infections. Stress or anxiety can also trigger sneezing in dogs. Owners should monitor their dog’s behavior and seek veterinary advice if sneezing persists or worsens.',
  },
  {
    action: 'Shivering or Trembling',
    meaning:
      'Dogs shiver and tremble for all kinds of reasons -- excitement, cold, pain, old age, even nausea. Shivering and trembling may be symptoms of something serious -- like poisoning, kidney disease, or injury.',
  },
  {
    action: 'Shaking',
    meaning:
      'Shaking is an effective method for dogs to relieve stress and indicate a need for space. However, persistent shaking could potentially indicate an ear infection, so it’s important to monitor this behavior if it occurs frequently.',
  },
  {
    action: 'Circling before lying down',
    meaning:
      'Dogs will circle a comfy spot before actually lying down because their ancestors did the same thing before turning in for the night. Sure, wolves had to do it to prep their bed of leaves for a good night’s rest, but your dog doesn’t know the difference.',
  },
  {
    action: 'Circling before pooping',
    meaning:
      'When a dog circles round and round before he poops, he is doing several things. He is ensuring his safety, cleaning his spot, and leaving his calling card. Dogs communicate a lot of messages through their excretions and setting it up is important.',
  },
  {
    action: 'Destructive behavior when left alone',
    meaning:
      'Dogs who destroy stuff while you’re out of the house (and only while you’re out of the house) are likely suffering from separation anxiety. They’re lashing out because they’re afraid and in need of attention.',
  },
  {
    action: "Destructive behavior when you're at home",
    meaning:
      'Lack of exercise or proper training can result in a dog with excess energy and/or the inability to resist destroying property.',
  },
  {
    action: 'Smiling',
    meaning:
      'This “dog smile” usually occurs in situations when they are relaxed and appear happy, which is why dog owners think it is a smile. These “dog smiles” also often occur in response to a human smile, which is a phenomenon called laughter contagion.',
  },
  {
    action: 'Shutting down',
    meaning:
      'Refusing to eat, pulling away when you reach out to her and growing lethargic are all signs your dog is anxious, fearful or ill. Shutting down like this requires a lot of observation on your part to figure out the cause, so be aware of other vocal and physical signs.',
  },
  {
    action: 'Play Bow',
    meaning:
      'When a dog lowers their front legs and keeps their rear end up, it’s an open invitation to play and signals friendliness. It’s often accompanied by a wagging tail, bouncy movements, and an eager expression, showing they are in a joyful and non-threatening mood.',
  },
  {
    action: 'Leaning on You',
    meaning:
      'A sign of affection, trust, and the desire for closeness. Dogs may lean on you for physical comfort, to feel secure in unfamiliar situations, or simply to bond and enjoy your presence.',
  },
  {
    action: 'Freezing in Place',
    meaning:
      'A still, tense posture that can signal fear, discomfort, or hesitation. This pause may happen before the dog reacts, such as deciding whether to flee, approach, or defend itself, and is an important cue to give them space.',
  },
  {
    action: 'Barking Rapidly',
    meaning:
      'A series of fast, repetitive barks often signals heightened alertness, excitement, or urgency. The pitch and tone provide more context—higher pitches often mean excitement or friendliness, while deeper pitches may signal warning or protection.',
  },
  {
    action: 'Pawing at You',
    meaning:
      'A direct request for attention, play, or physical contact. Dogs may also use pawing to communicate needs like food, going outside, or expressing affection in a gentle, tactile way.',
  },
  {
    action: 'Jumping Up',
    meaning:
      'Often a display of excitement, joy, or greeting behavior. While it can be an affectionate gesture, it’s sometimes an attempt to gain attention or reach your face, and may need training to manage if excessive.',
  },
  {
    action: 'Nudging with Nose',
    meaning:
      'A gentle push of the nose used to gain attention, request petting, or indicate they want something—such as food, a toy, or for you to move. It’s a subtle but clear form of canine communication.',
  },
  {
    action: 'Carrying a Toy to You',
    meaning:
      'Bringing you a toy is both a request to play and a sign of trust, as they are sharing a prized possession. It can also be a way of bonding or showing off something they’re proud of.',
  },
  {
    action: 'Snapping Without Contact',
    meaning:
      'A quick, deliberate snap of the jaws without actually biting. This is a warning signal, often the last step before a bite, used to communicate discomfort, fear, or a strong desire for space.',
  }

];
